module.exports = __webpack_public_path__ + "img/defaultMarker.758748d1.svg";